import React from 'react';
import { Trans } from 'react-i18next';
import { createUseStyles } from 'react-jss';
import { Button } from '@app/core';
import { Theme } from '@app/theme';

const useStyles = createUseStyles((theme: Theme) => ({
  container: {
    ...theme.fonts.label,
    padding: 0,
    marginTop: theme.marginBase * 3,
    fontWeight: 400,
  },
  button: {
    minWidth: 0,
    paddingLeft: theme.marginBase / 2,
    '&:hover:not(:disabled)': {
      backgroundColor: 'transparent',
    },
  },
  buttonContent: {
    padding: 0,
    '& i': {
      fontWeight: 400,
      fontSize: theme.iconSize.small,
    },
  },
}));

interface Props {
  text: string;
  to: string;
}

export const LinkSentence = ({ text, to }: Props) => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <Trans
        i18nKey={text}
        components={[
          <Button
            href={to}
            color="blue"
            variant="transparent"
            small
            withNextArrow
            className={classes.button}
            contentClassName={classes.buttonContent}
          />,
        ]}
      />
    </div>
  );
};
